import { ModalService } from './../../../base/shared/modal/modal.service';
import { UpdateExportInterfaceEmailTemplateDTO } from 'src/app/base/models/models.swagger.generated';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ExportInterfaceEmailTemplateDTO, IUpdateExportInterfaceEmailTemplateDTO } from './../../../base/models/models.swagger.generated';
import { Component, OnInit, ViewChild } from '@angular/core';
import { EmailTemplatesOverviewService } from 'src/app/domain/export-configuration/shared/email-templates-overview/email-templates-overview.service';
import { EmailTemplatesOverviewComponent } from 'src/app/domain/export-configuration/shared/email-templates-overview/email-templates-overview.component';
import { merge, Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { TranslateModule } from '@ngx-translate/core';
import { EmailTemplateFormComponent } from './email-template-form/email-template-form.component';

import { EmailTemplatesOverviewComponent as EmailTemplatesOverviewComponent_1 } from '../shared/email-templates-overview/email-templates-overview.component';
import { TitleBarComponent } from '../../../base/shared/title-bar/title-bar.component';
import { NavigationEnd, Router } from '@angular/router';
import { emailTemplatesExpConfRoute } from 'src/app/core/routing/route-names';
import { UrlHelper } from 'src/app/base/shared/url-helper';
import * as pages from '../../../core/routing/page-names';
import { ToastService } from 'src/app/base/services/toast.service';

@Component({
    selector: 'app-email-templates',
    templateUrl: './email-templates.component.html',
    styleUrls: ['./email-templates.component.scss'],
    imports: [TitleBarComponent, EmailTemplatesOverviewComponent_1, EmailTemplateFormComponent, TranslateModule]
})
export class EmailTemplatesComponent implements OnInit{

  @ViewChild(EmailTemplatesOverviewComponent) templateOverviewComponent: EmailTemplatesOverviewComponent;

  public emailTemplate: ExportInterfaceEmailTemplateDTO;
  public emailTemplateForm: UntypedFormGroup;

  public selectedTemplateId : number;

  constructor(
    private templateService: EmailTemplatesOverviewService,
    private fb: UntypedFormBuilder,
    private modalService: ModalService,
    private router: Router,
    private toastService: ToastService
  ) { }

  ngOnInit() {
    this.initForm();

    this.router.events.pipe(filter(event => event instanceof NavigationEnd && event.url.includes(emailTemplatesExpConfRoute))).subscribe(() => {
      this.urlChanged();
    });

    // call the first time urlChanged on our own
    this.urlChanged();
  }

  public urlChanged(): void {
    var id = UrlHelper.getIdForSegment(pages.emailTemplatesPageName, this.router)
    if (id != null){
      this.selectedTemplateId = id;
    } else {
      this.selectedTemplateId = null;
    }
  }

  public addTemplate() {
    this.templateService.addRecord().subscribe((data: ExportInterfaceEmailTemplateDTO) => {
      this.templateOverviewComponent.recordAdded(data.id);
    });
  }

  public closeTemplate() {
    this.templateOverviewComponent.resetRowSelected();
    this.emailTemplate = null;
    this.emailTemplateForm.reset();
    this.emailTemplateForm.markAsPristine();
    this.router.navigate([emailTemplatesExpConfRoute]);
  }

  public deleteTemplate() {
    const dialog = this.modalService.showOkCancelDialog('i18n.domain.export-configuration.email-templates.delete-dialog.title', 'i18n.domain.export-configuration.email-templates.delete-dialog.question');
    dialog.onOkSubject.subscribe(() => {
      this.templateService.deleteRecord(this.emailTemplate.id).subscribe(() => {
        this.templateOverviewComponent.refresh();
      });
      this.closeTemplate();
    });
  }

  public saveTemplate() {
    this.emailTemplateForm.markAllAsTouched();
    if (this.emailTemplateForm.invalid) {
      this.toastService.showWarning('i18n.domain.export-configuration.configurations.messages.form-invalid.title',
        'i18n.domain.export-configuration.configurations.messages.form-invalid.message', null);
      return;
    }
    const templateValues = this.emailTemplateForm.getRawValue() as IUpdateExportInterfaceEmailTemplateDTO;
    templateValues.id = this.emailTemplate.id;
    this.templateService.updateRecord(new UpdateExportInterfaceEmailTemplateDTO(templateValues)).subscribe({next: () => {
      this.closeTemplate();
      this.templateOverviewComponent.refresh();
    }, error: (error) => {
      // we just catch since warnings are handled in service
    }});
  }

  public templateSelected(selectedEmailTemplate: ExportInterfaceEmailTemplateDTO) {
    this.emailTemplate = selectedEmailTemplate;
    this.loadDataToForm(selectedEmailTemplate);

    if (selectedEmailTemplate?.id != null) {
      this.router.navigate([emailTemplatesExpConfRoute + "/" + selectedEmailTemplate.id]);
    } else {
      this.router.navigate([emailTemplatesExpConfRoute]);
    }
  }

  private initForm() {
    this.emailTemplateForm = this.fb.group({
      templateName: [null, Validators.required],
      senderName: [null, Validators.required],
      subject: [null, Validators.required],
      textHTML: [null, Validators.required],
      emailAccountId: [null, Validators.required],
    });
  }

  private loadDataToForm(data: ExportInterfaceEmailTemplateDTO) {
    this.emailTemplateForm = this.fb.group({
      templateName: [data.templateName, Validators.required],
      senderName: [data.senderName, Validators.required],
      subject: [data.subject, Validators.required],
      textHTML: [data.textHTML, Validators.required],
      emailAccountId: [data.emailAccountId, Validators.required],
    });
  }

  canDeactivate(): Observable<boolean> | boolean {
    if (this.emailTemplateForm.dirty) {
      const dialog = this.modalService.showOkCancelDialog('i18n.domain.export-configuration.email-templates.discard-dialog.title', 'i18n.domain.export-configuration.email-templates.discard-dialog.question');
      return merge(
        dialog.onOkSubject.pipe(map(() => true)),
        dialog.onCancelSubject.pipe(map(() => false)),
      );
    }
    return true;
  }
}
